import { EnvironmentOutlined } from '@ant-design/icons';
import { Map } from 'leaflet';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { setMap } from 'redux/reducer/MapReducer/mapReducer';
import { RootState, store } from 'redux/store';
import TcMapView from './components/layout/TcMapView';

interface ILocationPicker {
  setMap?: React.Dispatch<React.SetStateAction<Map | undefined>>;
  setSelectedLocation: (_latlng: { lat: number; lng: number }) => void;
  selectedLocation?: { lat: number; lng: number };
  showCurrentLocation?: boolean;
}

const LocationPicker: FC<ILocationPicker> = ({ selectedLocation, setSelectedLocation, showCurrentLocation = false }) => {
  //states
  const { map } = useSelector((state: RootState) => state.map);
  const [canGetCurrentLocation, setCanGetCurrentLocation] = useState<boolean>(false);

  //effect
  useEffect(() => {
    if (window.navigator.geolocation) setCanGetCurrentLocation(true);
  }, []);

  useEffect(() => {
    if (!map) return;
    const handleClick = (e: any) => setSelectedLocation(e.latlng);
    map.on('click', handleClick);
    setMap && store.dispatch(setMap(map));
    return () => {
      map.off('click', handleClick);
    };
  }, [map, setMap, setSelectedLocation]);

  useEffect(() => {
    if (selectedLocation && map) {
      // @ts-ignore
      map.flyTo([selectedLocation.lat, selectedLocation.lng], 11);
    }
  }, [selectedLocation, map]);

  //functions
  const getUserCurrentLocation = () => {
    window.navigator.geolocation.getCurrentPosition((position) => {
      setSelectedLocation({ lat: position.coords.latitude, lng: position.coords.longitude });
      map?.flyTo([position.coords.latitude, position.coords.longitude]);
    });
  };

  return (
    <>
      {showCurrentLocation && canGetCurrentLocation && (
        <div className='flex justify-end'>
          <span
            className='flex px-2 py-1 mb-2 text-sm rounded-md cursor-pointer hover:bg-t-layer-bg-color-hovered w-fit gap-x-2 bg-t-layer-bg-color'
            onClick={getUserCurrentLocation}>
            <EnvironmentOutlined />
            لوکیشن فعلی
          </span>
        </div>
      )}
      <TcMapView selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} />
    </>
  );
};

export default LocationPicker;
